import React from 'react'
import './teacher-calendar-large-view-event.css'
import { ChevronLeftIcon } from '@heroicons/react/20/solid'
import { format, isValid, addMinutes, getHours, getMinutes } from 'date-fns'
import LargeViewEventEdit from './LargeViewEventEdit/LargeViewEventEdit'
import LargeViewMultipleEventWarning from './LargeViewMultipleEventWarning/LargeViewMultipleEventWarning'
import LargeViewSaveChangesPopup from './LargeViewSaveChangesPopup/LargeViewSaveChangesPopup'
import { EditingEventAnimation, KeepEditingAnimation, MultipleEventEditsAnimation, DeleteEventWarningAnimation } from '../MonthView/TeacherCalendarMonthViewLarge/LargeEventAnimations'
import LargeViewMultipleDeleteWarning from './LargeViewMultipleDeleteWarning/LargeViewMultipleDeleteWarning'
import TeacherCalendarCancellationFlow from '../TeacherCalendarCancellationFlow/TeacherCalendarCancellationFlow'

const TeacherCalendarLargeViewEvent = ({event, setOpenEvent, setEventObjectToEdit, setAllEvents, socket, initialDateTimeRef}) => {
    const [editing, setEditing] = React.useState(false)
    const [changeMultipleEvents, setChangeMultipleEvents] = React.useState(false)
    const [keepEditing, setKeepEditing] = React.useState(false)
    const [deletingEventWarning, setDeletingEventWarning] = React.useState(false)
    const [somethingWasChanged, setSomethingWasChanged] = React.useState(false)

    //ANIMATIONS
    React.useEffect(() => document.getElementById('teacher-calendar-event-wrapper') && EditingEventAnimation(editing), [editing])
    React.useEffect(() => document.getElementById('teacher-calendar-event-editing__repeat-event__wrapper') && MultipleEventEditsAnimation(changeMultipleEvents), [changeMultipleEvents])
    React.useEffect(() => document.getElementById('teacher-calendar-event-deleting__repeat-event__wrapper') && DeleteEventWarningAnimation(deletingEventWarning)  ,[deletingEventWarning])
    React.useEffect(() => document.getElementById('teacher-calendar-event-editing__repeat-event-keep-editing__wrapper') && KeepEditingAnimation(keepEditing), [keepEditing])
    React.useEffect(() => {
        if(document.getElementById('teacher-calendar-event-wrapper')) {
            setTimeout(() => {
                if(event) {
                    socket.emit('openCalendarEvent', {emitter: event.teacherName, packet: event})
                    document.getElementById('teacher-calendar-event-wrapper').style.marginLeft = '0px'
                    document.getElementById('teacher-calendar-event-wrapper__black-background').style.opacity = 1
                } else {
                    document.getElementById('teacher-calendar-event-wrapper').style.marginLeft = '100vw'
                }
            }, 0)
        }
    }, [event])
    //---------------

    const closeBoth = () => {
        setKeepEditing(false)
        setEditing(false)
    }

    const closingAnimation = () => {
        document.getElementById('teacher-calendar-event-wrapper').style.marginLeft = '100vw'
        document.getElementById('teacher-calendar-event-wrapper__black-background').style.opacity = 0
        setTimeout(() => {setOpenEvent(false)}, 300)
    }

    const tryToClosePopup = (id) => {
        id === 'teacher-calendar-event-editing__repeat-event__wrapper' && setChangeMultipleEvents(false)
        id === 'teacher-calendar-event-editing__repeat-event-keep-editing__wrapper' && setKeepEditing(false)
        id === 'teacher-calendar-event-deleting__repeat-event__wrapper' && setDeletingEventWarning(false)
    }

    if(event) {
        return (
            <div className='teacher-calendar-event-wrapper__black-background' id='teacher-calendar-event-wrapper__black-background'>
                <div className='teacher-calendar-event-wrapper' id='teacher-calendar-event-wrapper'>
                    <div className='teacher-calendar-event__top-bar'>
                        <div onClick={() => closingAnimation(false)} className='teacher-calendar-event__top-bar__back-btn'>
                            <ChevronLeftIcon className="h-7 w-7 text-red-600" aria-hidden="true" />
                            {isValid(new Date(event.dateTime)) && <p>{format(new Date(event.dateTime), 'MMM dd')}</p>}
                        </div>
                        <div className='teacher-calendar-event__top-bar__title'>Event Details</div>
                        <div className='teacher-calendar-event__top-bar__edit' onClick={() => setEditing(true)}>Edit</div>
                    </div>
                    <div className='teacher-calendar-event__event-name'>{event.name}</div>
                    <div className='teacher-calendar-event__time-details__wrapper'>
                        {isValid(new Date(event.dateTime)) && <div className='teacher-calendar-event__time-details-date'>{format(new Date(event.dateTime), 'EEEE')}, {format(new Date(event.dateTime), 'MMM')} {format(new Date(event.dateTime), 'd')}, {format(new Date(event.dateTime), 'yyyy')}</div>}
                        {isValid(new Date(event.dateTime)) && <div className='teacher-calendar-event__time-details-time'>from {event.time} to {format(addMinutes(new Date(event.dateTime), event.lessonLength), 'p')}</div>}
                        <div className='teacher-calendar-event__time-details-lesson-length'>{event.lessonLength} minute lesson</div>
                        {event.recurring.isOn && <div className='teacher-calendar-event__time-details-lesson-recurring'>repeats {event.recurring.frequency}</div>}
                    </div>
                    <div className='teacher-calendar-event__family-details__wrapper'>
                        <div className='teacher-calendar-event__family-details__title'>Family Info</div>
                        <div className='teacher-calendar-event__family-details'>
                            <div className='teacher-calendar-event__family-details__label'>Parent Name:</div>
                            <div className='teacher-calendar-event__family-details__info'>{event.parentName}</div>
                        </div>
                        <div className='teacher-calendar-event__family-details'>
                            <div className='teacher-calendar-event__family-details__label'>Phone Number:</div>
                            <div className='teacher-calendar-event__family-details__info'>{event.familyPhoneNumber}</div>
                        </div>
                        <div className='teacher-calendar-event__family-details'>
                            <div className='teacher-calendar-event__family-details__label'>Email:</div>
                            <div className='teacher-calendar-event__family-details__info'>{event.familyEmail}</div>
                        </div>
                        <div className='teacher-calendar-event__family-details'>
                            <div className='teacher-calendar-event__family-details__label'>Address:</div>
                            <div className='teacher-calendar-event__family-details__info'>{event.familyAddress.addressLine1}<br></br>{event.familyAddress.city} {event.familyAddress.state}<br></br>{event.familyAddress.zipcode}</div>
                        </div>
                    </div>
                    <div className='teacher-calendar-event__delete-btn' onClick={() => setDeletingEventWarning(true)}>Cancel Lesson</div>
                </div>
                <LargeViewEventEdit event={event} setOpenEvent={setOpenEvent} setEditing={setEditing} setKeepEditing={setKeepEditing} setChangeMultipleEvents={setChangeMultipleEvents} setEventObjectToEdit={setEventObjectToEdit} somethingWasChanged={somethingWasChanged} setSomethingWasChanged={setSomethingWasChanged} setAllEvents={setAllEvents} socket={socket} />
                <LargeViewSaveChangesPopup tryToClosePopup={tryToClosePopup} closeBoth={closeBoth} setKeepEditing={setKeepEditing} />
                <LargeViewMultipleEventWarning event={event} setOpenEvent={setOpenEvent} setEditing={setEditing} setAllEvents={setAllEvents} tryToClosePopup={tryToClosePopup} setChangeMultipleEvents={setChangeMultipleEvents} socket={socket} initialDateTimeRef={initialDateTimeRef} />
                {/* <LargeViewMultipleDeleteWarning event={event} setOpenEvent={setOpenEvent} setDeletingEventWarning={setDeletingEventWarning} setAllEvents={setAllEvents} tryToClosePopup={tryToClosePopup} /> */}
                {deletingEventWarning && <TeacherCalendarCancellationFlow open={deletingEventWarning} setOpen={setDeletingEventWarning} event={event} setAllEvents={setAllEvents} setOpenEvent={setOpenEvent} socket={socket} />}
            </div>
        )
    } else {
        return(
            <div></div>
        )
    }
}
export default TeacherCalendarLargeViewEvent